import React from 'react';

export const PadSurveyContext = React.createContext();

export const usePadSurveyContext = () => {
  const context = React.useContext(PadSurveyContext);

  return context;
};
